import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propShape, } from '../../../../../../../helpers/custom-prop-types';
import LockIcon from '../../../../../../Icon/Svg/LockIcon';
import HtmlLink from '../../../../../../Ui/Common/HtmlLink';
import Hover from '../../../../../../Ui/System/Hover';
const SlideSearchHeaderSideMenuSpButtons = (props) => {
    const { className, links } = props;
    const buttonLinks = [links.addSlide, links.addAccount];
    return (_jsx("ul", Object.assign({ className: clsx('slide_search_header_side_menu_sp_buttons', className) }, { children: buttonLinks.map((v) => (_jsx(Hover, { children: _jsxs("li", Object.assign({ className: clsx('button_item', v.isDisabled && 'lock') }, { children: [_jsxs(HtmlLink, Object.assign({ className: clsx('button_link', v.className), isNoLinkComponent: v.onClick ? 'button' : undefined, onClickNoLink: v.onClick, to: v.to }, { children: [_jsx("span", Object.assign({ className: 'link_icon' }, { children: v.icon })), _jsx("span", Object.assign({ className: 'link_text' }, { children: v.text }))] })), v.isDisabled && _jsx(LockIcon, { className: 'link_lock' })] })) }, v.text))) })));
};
SlideSearchHeaderSideMenuSpButtons.propTypes = {
    className: propStr(),
    links: propShape().isRequired,
};
SlideSearchHeaderSideMenuSpButtons.defaultProps = {
    className: '',
};
export default SlideSearchHeaderSideMenuSpButtons;
